import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Generic full-size image viewer. Give it an image URL (and optionally a title); it shows the
 * image at its natural size, capped to the viewport. A missing or broken URL falls back to a
 * fixed-size placeholder instead of a broken-image icon, so the modal always looks intentional.
 *
 * Open with `BsModalService.show(ImageViewerModalComponent, { initialState: { imageUrl, title } })`.
 */
@Component({
  selector: 'app-image-viewer-modal',
  templateUrl: './image-viewer-modal.component.html',
  styleUrls: ['./image-viewer-modal.component.scss'],
})
export class ImageViewerModalComponent {
  @Input() imageUrl?: string | null;
  @Input() title?: string;

  isBroken = false;

  constructor(public modal: BsModalRef) {}

  get showPlaceholder() {
    return !this.imageUrl || this.isBroken;
  }

  onError() {
    this.isBroken = true;
  }
}
